<hpf-module-qcm-form
	*ngIf="moduleQCM"
	[moduleQCM]="moduleQCM"
	(create)="onCreate($event)"
></hpf-module-qcm-form>
<div *ngIf="!moduleQCM" class="my-5 text-center">
	<nz-spin nzSimple></nz-spin>
</div>
